<template>
  <section>
    <div class="son_shouxin">
      <div class="title">结算数据</div>
      <div class="son_list flex ">
        <div class="son_item order" v-for="(item, index) in companylist.data" :key="index">
          <div class="sonName flex ju-be">
            <span class="company bold12">{{item.title}}</span> 
            <!-- <span class="mingxi">查看明细</span> -->
          
          </div>
          <div class="sonData flex ju-ar">
            <li class="sonData_item">
              <span class="bold18">{{item.data.authpaid}}</span>
              <br />
              <span class="normal12">已结算金额</span>
            </li>
            <li class="sonData_item">
              <span class="bold18">{{item.data.authamount-item.data.authpaid}}</span>
              <br />
              <span class="normal12">未结算金额</span>
            </li>
            <!-- <li class="sonData_item">
              <span class="bold18">99900.22</span>
              <br />
              <span class="normal12">剩余额度(元)</span>
            </li> -->
          </div>
        </div>
      </div>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="companylist.per_page"
        @current-change="currentPage"
        :total="companylist.total"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
export default {
  name: "son_shouxin",
  data() {
    return {
      page: 1,
      companylist:{},
    };
  },

  methods: {
    currentPage(e) {
      this.page = e;
      this.getcompanylist();
    },
    async getcompanylist(){
      let companylist = await this.$fetch("shop/companylist", {
        body: { isauthpaid: "2",isexpire:"1",page:this.page }
      });
      this.companylist=companylist;
      console.log("企业的订单数据",companylist)
    },
  },

  async mounted() {
    this.getcompanylist();
  }
};
</script>

  


<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/son_jiesuan.vue